export default __webpack_public_path__ + "static/media/horiseon.cc391b1a.png";